module.exports = __webpack_public_path__ + "static/media/03.fe685e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/supplements/03.png
// module id = 644
// module chunks = 0